module.exports = __webpack_public_path__ + "assets/candidate-profile-logo.64618618.png";